"use client";

import React from "react";
import { ExternalLink, Building2, Handshake, ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
const partners = [{
  id: 1,
  name: "NUCEWALL",
  shortDesc: "Giải pháp tấm tường bê tông nhẹ công nghệ cao.",
  mission: "Cung cấp giải pháp vật liệu xây dựng xanh, nhẹ và bền vững cho các công trình hiện đại.",
  key_services: "Sản xuất tấm tường Acotec, tư vấn giải pháp lắp ghép, chuyển giao công nghệ vật liệu.",
  location: "Hà Nội, Việt Nam",
  website_url: "https://nucewall.vn",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_nucewall.png"
}, {
  id: 2,
  name: "FRP Vietnam",
  shortDesc: "Chuyên gia vật liệu Composite trong xây dựng.",
  mission: "Ứng dụng vật liệu mới FRP để gia cường kết cấu và chống ăn mòn cho các công trình hạ tầng.",
  key_services: "Thi công gia cường sợi Carbon (CFRP), cung cấp vật liệu Composite, tư vấn kỹ thuật chuyên sâu.",
  location: "TP. Hồ Chí Minh, Việt Nam",
  website_url: "https://frpvietnam.com",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_frp.png"
}, {
  id: 3,
  name: "Delta Group",
  shortDesc: "Tập đoàn xây dựng hàng đầu Việt Nam.",
  mission: "Xây dựng những công trình đẳng cấp với chất lượng và kỹ thuật thi công hàng đầu.",
  key_services: "Tổng thầu xây dựng, thi công hầm sâu, công trình cao tầng và đại đô thị.",
  location: "Hà Nội, Việt Nam",
  website_url: "https://deltagroup.vn",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_delta.png"
}, {
  id: 4,
  name: "CCU",
  shortDesc: "Công ty Tư vấn Đại học Xây dựng.",
  mission: "Kết nối tri thức hàn lâm với thực tiễn sản xuất thông qua các dịch vụ tư vấn thiết kế chất lượng cao.",
  key_services: "Tư vấn thiết kế, giám sát thi công, kiểm định chất lượng công trình xây dựng.",
  location: "Hà Nội, Việt Nam",
  website_url: "https://ccu.vn",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_ccu.webp"
}, {
  id: 5,
  name: "Xây Dựng Số",
  shortDesc: "Sàn giao dịch và kết nối ngành xây dựng.",
  mission: "Số hóa quy trình tìm kiếm nhà thầu và minh bạch hóa thị trường xây dựng Việt Nam.",
  key_services: "Kết nối chủ đầu tư và nhà thầu, tư vấn đấu thầu, giải pháp chuyển đổi số ngành xây dựng.",
  location: "Toàn quốc",
  website_url: "https://xaydungso.vn",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_xaydungso.webp"
}, {
  id: 6,
  name: "VITECS",
  shortDesc: "Viện Công nghệ và Giải pháp Xây dựng.",
  mission: "Nghiên cứu và ứng dụng các công nghệ tiên tiến nhất vào quy trình quản lý và thi công.",
  key_services: "Nghiên cứu khoa học, kiểm định vật liệu, tư vấn giải pháp kỹ thuật công nghệ cao.",
  location: "Hà Nội, Việt Nam",
  website_url: "https://vitecs.vn",
  coverSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/partner_vitecs.webp"
}];
const partnerGalleries = [{
  partnerId: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_nucewall_factory.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_nucewall_factory.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_nucewall_factory.png-wvc-sizes",
  alt: "Nhà máy sản xuất NUCEWALL"
}, {
  partnerId: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_frp_project.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_frp_project.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_frp_project.png-wvc-sizes",
  alt: "Dự án gia cường kết cấu FRP"
}, {
  partnerId: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_delta_site.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_delta_site.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_delta_site.png-wvc-sizes",
  alt: "Công trường thi công Delta Group"
}, {
  partnerId: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ccu_design.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ccu_design.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/gallery_ccu_design.png-wvc-sizes",
  alt: "Văn phòng thiết kế CCU"
}];
export default function AffiliatePartners() {
  return <section id="affiliatepartners" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <Badge variant="outline" className="mb-4 border-primary text-primary">
            Mạng lưới hợp tác
          </Badge>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Liên kết & Đối tác Chiến lược
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl">
            NUCETECH tự hào đồng hành cùng các tổ chức, doanh nghiệp và viện nghiên cứu hàng đầu, kiến tạo hệ sinh thái đổi mới sáng tạo bền vững cho ngành xây dựng Việt Nam.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {partners.map((partner, i) => <div data-index={i} key={partner.id} className="h-full">
              <Dialog>
                <DialogTrigger asChild>
                  <Card className="group relative h-full overflow-hidden cursor-pointer border border-border p-4 hover:border-primary transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 rounded-xl">
                    <AspectRatio ratio={3 / 2} className="w-full overflow-hidden rounded-lg mb-4">
                      <img src={partner.coverSrc} data-wvc-srcset={`${partner.coverSrc}-wvc-srcset`} data-wvc-sizes={`${partner.coverSrc}-wvc-sizes`} alt={partner.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100" loading="lazy" />
                    </AspectRatio>
                    <div className="flex flex-col items-center text-center">
                      <h3 className="font-default text-primary font-bold text-lg leading-tight mb-2 transition-colors group-hover:text-primary/80">
                        {partner.name}
                      </h3>
                      <div className="flex items-center text-primary font-medium text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <span>Xem chi tiết</span>
                        <ArrowRight className="ml-2 size-4" />
                      </div>
                    </div>
                  </Card>
                </DialogTrigger>

                <DialogContent className="w-[70vw] h-[80vh] p-0 overflow-hidden gap-0 bg-background border-border rounded-xl shadow-2xl" showCloseButton={false}>
                  <div className="bg-primary text-primary-foreground p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-4 relative">
                    <div className="z-10">
                      <DialogTitle className="font-default text-2xl md:text-3xl font-bold mb-2 text-primary-foreground">
                        {partner.name}
                      </DialogTitle>
                      <DialogDescription className="text-primary-foreground/80 flex items-center gap-2 text-sm md:text-base">
                        <MapPin className="size-4" />
                        {partner.location}
                      </DialogDescription>
                    </div>
                    <Button variant="secondary" size="sm" asChild className="w-fit z-10 shadow-md">
                      <Link to={partner.website_url || "#"} newTab>
                        <ExternalLink className="mr-2 size-4" />
                        Truy cập Website
                      </Link>
                    </Button>
                    
                    <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-black/20 to-transparent pointer-events-none" />
                  </div>

                  <ScrollArea className="max-h-[70vh] md:max-h-[600px]">
                    <div className="p-6 md:p-8">
                      <div className="mb-10">
                        <Carousel opts={{
                      align: "start",
                      loop: true
                    }} className="w-full">
                          <CarouselContent>
                            {partnerGalleries.filter(g => g.partnerId === partner.id).length > 0 ? partnerGalleries.filter(g => g.partnerId === partner.id).map((gallery, index) => <CarouselItem key={index} data-index={index} className="md:basis-1/2 lg:basis-2/3">
                                  <div className="p-1">
                                    <Card className="overflow-hidden border-0 shadow-md rounded-lg">
                                      <AspectRatio ratio={16 / 9}>
                                        <img src={gallery.src} data-wvc-srcset={gallery.srcset} data-wvc-sizes={gallery.sizes} alt={gallery.alt} className="object-cover w-full h-full" loading="lazy" />
                                      </AspectRatio>
                                    </Card>
                                  </div>
                                </CarouselItem>) : <CarouselItem data-index={0} className="md:basis-1/2 lg:basis-2/3">
                                <div className="p-1">
                                  <Card className="overflow-hidden border-0 shadow-md rounded-lg">
                                    <AspectRatio ratio={16 / 9}>
                                      <img src={partner.coverSrc} data-wvc-srcset={`${partner.coverSrc}-wvc-srcset`} data-wvc-sizes={`${partner.coverSrc}-wvc-sizes`} alt={partner.name} className="object-cover w-full h-full" loading="lazy" />
                                    </AspectRatio>
                                  </Card>
                                </div>
                              </CarouselItem>}
                          </CarouselContent>
                          <div className="flex justify-end gap-2 mt-4 pr-4">
                            <CarouselPrevious className="relative inset-0 translate-y-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
                            <CarouselNext className="relative inset-0 translate-y-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
                          </div>
                        </Carousel>
                      </div>

                      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="p-2 bg-primary/10 rounded-lg text-primary">
                              <Building2 className="size-6" />
                            </div>
                            <h4 className="font-default text-xl font-semibold text-foreground">
                              Về Đối Tác
                            </h4>
                          </div>
                          <div className="space-y-4">
                            <div>
                              <p className="text-xs font-bold uppercase tracking-wider text-primary mb-1">Sứ mệnh</p>
                              <p className="text-muted-foreground leading-relaxed">
                                {partner.mission}
                              </p>
                            </div>
                            <div>
                              <p className="text-xs font-bold uppercase tracking-wider text-primary mb-1">Dịch vụ chính</p>
                              <p className="text-muted-foreground leading-relaxed">
                                {partner.key_services}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="p-2 bg-primary/10 rounded-lg text-primary">
                              <Handshake className="size-6" />
                            </div>
                            <h4 className="font-default text-xl font-semibold text-foreground">
                              Hợp Tác Cùng NUCETECH
                            </h4>
                          </div>
                          <p className="text-muted-foreground leading-relaxed">
                            NUCETECH và {partner.name} duy trì mối quan hệ hợp tác chiến lược sâu rộng, tập trung vào việc ứng dụng các công nghệ xây dựng mới nhất và chuyển đổi số quy trình quản lý dự án. Hai bên cùng phối hợp triển khai các đề tài nghiên cứu cấp quốc gia và cung cấp giải pháp tư vấn kỹ thuật chuyên sâu cho các công trình hạ tầng trọng điểm tại Việt Nam.
                          </p>
                        </div>
                      </div>
                    </div>
                  </ScrollArea>
                  
                  <div className="absolute top-4 right-4 z-50">
                     <DialogTrigger asChild>
                        <Button variant="ghost" size="icon" className="text-primary-foreground/70 hover:text-primary-foreground hover:bg-primary-foreground/20 rounded-lg">
                          <span className="sr-only">Đóng</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-5"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                        </Button>
                     </DialogTrigger>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}